module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bg_f5f6f9"
  }), _vm._v(" "), _c('div', {
    staticClass: "root"
  }, [_c('div', {
    staticClass: "h4"
  }, [_vm._v("1.把智能红外遥控器对准家用电器")]), _vm._v(" "), _c('p', [_vm._v("控制电器的红外信号是由智能红外遥控器发出的，所以请将智能红外遥控器置在家电可以直线接收信号的地方。")]), _vm._v(" "), _c('div', {
    staticClass: "h4"
  }, [_vm._v("2.最好测试三个键")]), _vm._v(" "), _c('p', [_vm._v("测试时建议尝试三个以上按键，如果您发现遥控器不好用，可以根据提示更换下一个遥控器试试。")]), _vm._v(" "), _c('div', {
    staticClass: "h4"
  }, [_vm._v("3.部分键不好用")]), _vm._v(" "), _c('p', [_vm._v("有可能部分键与您家遥控器不一致，这会在后续版本中解决，请选择您认为最好用的遥控器。")]), _vm._v(" "), _c('div', {
    staticClass: "h4"
  }, [_vm._v("4.遥控器都试了不好用")]), _vm._v(" "), _c('p', [_vm._v("有可能您家遥控器是新型号，这会在后续版本中增加。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1467a142"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Tutorial/Index.vue
// module id = 867
// module chunks = 1